import { useState } from "react"
import styles from "../components/PostsGea.module.css"

export enum Size {
  FB = "fb",
  Insta = "insta",
}
export enum LogoSide {
  Left = "left",
  Right = "right",
}
export enum LogoBackground {
  With = "with",
  Without = "without",
}
export enum PriceSide {
  Left = "left",
  Right = "right",
}
export enum TitleColor {
  Gray = "#575756",
  White = "white",
}

const variants: Record<Size, string> = {
  [Size.FB]: styles.Facebook,
  [Size.Insta]: styles.Instagram,
}

export type PostGeaState = ReturnType<typeof usePostGeaState>

const usePostGeaState = () => {
  const [size, setSize] = useState(Size.FB)
  const [logoSide, setLogoSide] = useState(LogoSide.Right)
  const [priceSide, setPriceSide] = useState(PriceSide.Left)
  const [titleColor, setTitleColor] = useState(TitleColor.White)
  const [logoBackground, setLogoBackground] = useState(LogoBackground.With)

  return {
    size,
    logoSide,
    priceSide,
    titleColor,
    logoBackground,
    setSize,
    setLogoSide,
    setPriceSide,
    setTitleColor,
    setLogoBackground,
    variant: variants[size],
  }
}

export default usePostGeaState
